import { Maybe } from '@aibees/shared/definition';

const MAX_LEADS = 1000000;
const MAX_MEETINGS = 1000;

export const validateLeads = (leads: Maybe<number>): string => {
  if (!leads)
    return 'Please enter the number of leads to calculate your credit usage.';
  if (isNaN(Number(leads))) return 'Please enter a valid number for leads.';
  if (Number(leads) > MAX_LEADS)
    return `Please enter a realistic number of leads.`;
  return '';
};

export const validateMeetings = (meetings: Maybe<number>): string => {
  if (!meetings) return 'Please enter the number of sales meetings.';
  if (isNaN(Number(meetings)))
    return 'Please enter a valid number for sales meetings.';
  if (Number(meetings) > MAX_MEETINGS)
    return `Please enter a realistic number of sales meetings.`;
  return '';
};

export const validateTicks = (
  validWorkEmail: boolean,
  mobilePhoneNumber: boolean,
  fullProfileEnrichment: boolean
): string => {
  if (!validWorkEmail && !mobilePhoneNumber && !fullProfileEnrichment)
    return 'Please select at least one data point to enrich per person.';
  return '';
};
